import { Layout as AntLayout } from 'antd';
import { usePermissions, useUserContext } from 'features/users';
import { useWindowSize } from 'hooks';
import {
  BriefcaseBusiness,
  House,
  Layers2,
  Podcast,
  SquareChartGantt,
  UserPlus,
  Users,
} from 'lucide-react';
import { useSideBar } from 'providers/side-bar-provider';
import { useEffect, useMemo } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import { SideBarWrapper, StyledMenu } from './side-bar.styles';
import { getActiveKeys } from './utils';

export const SideBar = () => {
  const { collapsed, toggleCollapsed } = useSideBar();
  const { isMobile } = useWindowSize();
  const location = useLocation();
  const permissions = usePermissions();
  const { menuItem }: any = useUserContext();
  const { Sider } = AntLayout;
  useEffect(() => {
    const closeMobileMenu = () => {
      if (isMobile && !collapsed) {
        toggleCollapsed();
      }
    };

    closeMobileMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const activeKeys = useMemo(() => {
    return getActiveKeys(location.pathname);
  }, [location.pathname]);

  if (!permissions) return null;
  const iconMap: { [key: string]: JSX.Element } = {
    House: <House />,
    BriefcaseBusiness: <BriefcaseBusiness />,
    UserPlus: <UserPlus />,
    Users: <Users />,
    SquareChartGantt: <SquareChartGantt />,
    Podcast: <Podcast />,
    Layers2: <Layers2 />,
  };

  const items = menuItem?.rc.map((item: any, i: number) => {
    if (item?.SubMenu?.length) {
      return {
        key: i,
        icon: <span className='icon_home'>{iconMap[item?.Icon]}</span>,
        label: <NavLink to={item?.Url}>{item?.Name}</NavLink>,
        children: item.SubMenu.map((child: any) => ({
          path: child.Url,
          label: <NavLink to={child.Url}>{child.Name || ''}</NavLink>,
        })),
      };
    } else {
      return {
        path: i,
        icon: <span className='icon_home'>{iconMap[item?.Icon]}</span>,
        label: <NavLink to={item?.Url}>{item?.Name}</NavLink>,
      };
    }
  });

  return (
    <SideBarWrapper className='sidebarl'>
      <Sider
        id='sideBar'
        data-testid='side-bar'
        breakpoint='lg'
        // theme='light'
        collapsible
        collapsed={collapsed}
        collapsedWidth={isMobile ? '0' : '48'}
        width={isMobile ? 260 : 250}
        onCollapse={toggleCollapsed}
        trigger={null}
        className='side-bar-sider'
      >
        <StyledMenu
          selectedKeys={activeKeys}
          defaultOpenKeys={!collapsed ? activeKeys : undefined}
          mode='inline'
          items={items}
          className='side-bar-menu'
        />
      </Sider>
    </SideBarWrapper>
  );
};
